import type { SxProps, Theme } from "@mui/material";
import { COLORS } from "components/consts";

export const rowLabelSx = {
  fontSize: "12px",
  color: "black",
  fontWeight: 600,
  marginBottom: "4px",
} as const;

export const placeholderSx = {
  color: "black",
  margin: "0",
  opacity: "0.4",
  fontSize: "14px",
  fontWeight: "500",
  fontStyle: "italic",
} as const;

export const requiredFieldSx = {
  color: "red",
  fontWeight: 600,
  fontSize: "12px",
} as const;

export const fieldLabelSx: SxProps<Theme> = {
  fontSize: "12px",
  color: "black",
  fontWeight: 600,
  mb: 0.5,
};

export const dialogPaperSx: SxProps<Theme> = {
  "& .MuiDialog-paper": {
    maxWidth: "600px",
    width: "100%",
    maxHeight: "90vh",
    overflow: "hidden",
  },
};

export const dialogTitleSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const dialogContentSx: SxProps<Theme> = {
  paddingTop: "0px",
  overflow: "auto",
  maxHeight: "calc(90vh - 120px)",
};

export const entitySelectSx: SxProps<Theme> = {
  height: "36px",
  width: "100%",
  borderRadius: "8px",
  fontWeight: 500,
  color: COLORS.Mainblue,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.Mainblue,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.Mainblue,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.Mainblue,
    borderWidth: "1px",
  },
  "& .MuiSelect-select": {
    padding: "8px 14px",
  },
  "& .MuiSvgIcon-root": {
    fill: COLORS.Mainblue,
  },
};

export const targetTypeOptionSx = (selected: boolean): SxProps<Theme> => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "36px",
  cursor: "pointer",
  border: "1px solid",
  borderColor: selected ? COLORS.Mainblue : "divider",
  borderRadius: "8px",
  px: 2,
  fontWeight: 500,
  color: selected ? COLORS.Mainblue : "text.secondary",
  backgroundColor: selected ? COLORS.White_Lilac : "transparent",
  "&:hover": {
    backgroundColor: selected ? COLORS.White_Lilac : "action.hover",
  },
});